import { SvgIconProps } from "@mui/material";
import { forwardRef } from "react";

import CogIcon from "./CogIcon";

export default forwardRef<SVGSVGElement, SvgIconProps>(function SettingsIcon(
  props: SvgIconProps,
  ref,
) {
  return <CogIcon ref={ref} {...props} />;
});
